/* eslint-disable */

import Pagination from '../modules/pagination';
import swipeScroll from '../modules/swipeScroll';
import { Tabpanel } from '../modules/trap'
import { ParamsData } from '../app';

export default el => {
    const paginations = [];
    const block_pagination = el.querySelector(".block-pagination");
    const tabpanels = el.querySelectorAll(".tabpanel");
    const tablist = el.querySelector(".tablist");
    const tabs_btn = tablist.querySelectorAll("button");



    // tabpanels
    const tab = new Tabpanel(tablist, tabpanels);
    tab.start();
    tab.onclick = (btn, i) => {
        window.history.pushState('', '', btn.dataset.url);
        display(1, btn.dataset.category, () => {
            tab.display();
        });
    }

    // tablist swipe en mobile touch et non touch
    swipeScroll(tablist);


    // pagination

    const slashify = (href) => {
        href += href.endsWith("/") ? "" : "/";
        return href
    }

    let url = window.location.pathname.split("page");
    let page = 1;
    if (url.length > 1) {
        page = Number(url[url.length - 1].replaceAll("/", ""))
    }

    tabs_btn.forEach((btn, i) => {
        const category = btn.dataset.category;
        const tabpanel = document.getElementById(`tabpanel-${category}`);
        paginations[category] = new Pagination(tabpanel);
        // set la pagination au chargement de la page
        paginations[category].set(Number(block_pagination.dataset.lastpage), page);
        paginations[category].click = (newpage, link) => {

            history.pushState({}, "", slashify(link.href));


            display(newpage, category, () => {
                tabpanel.querySelector("a").focus();
            });
        };
    })

    function display(page, category, onloaded) {
        const tabpanel = document.getElementById(`tabpanel-${category}`);
        const result = tabpanel.querySelector(".result");
        el.classList.add("load");

        const formData = new FormData();
        formData.append("nonce", el.dataset.nonce);
        formData.append("action", "articles");
        formData.set("page", page);
        formData.append("category", category);
        formData.set('itemsPerPage', 8);

        const xhr = new XMLHttpRequest();
        xhr.open("POST", ParamsData.wp_ajax_url, true);
        xhr.onload = () => {
            const response = JSON.parse(xhr.response);
            const page = Number(response.pagination.page);
            const last_page = Number(response.pagination.last_page);
            paginations[category].set(last_page, page);
            result.innerHTML = response.html;

            document.querySelector("#breadcrumb ol").innerHTML = response.breadcrumb;

            tablist.scrollIntoView({ behavior: "smooth" });

            el.classList.remove("load");

            if (typeof onloaded === "function") onloaded();
        }

        xhr.send(formData, "all");
    }
}